<template>


    <div class="pack"
         v-on:dblclick.prevent="dblClick"
         @click.prevent="click($event, 'pack')"
         :class="holderClass"
         v-bind:style="holderWithPx"
         title=""
    >
      <div class="front side" v-bind:style="front" @click.prevent.stop="click($event, 'front')" @mousedown="mousedown($event, 'front')" ></div>
      <div class="right side" v-bind:style="right" @click.prevent.stop="click($event, 'right')" @mousedown="mousedown($event, 'right')"></div>
      <div class="top side" v-bind:style="top" @click.prevent.stop="click($event, 'top')" @mousedown="mousedown($event, 'top')"></div>
      <div class="bottom side" v-bind:style="bottom" @click.prevent.stop="click($event, 'bottom')" @mousedown="mousedown($event, 'bottom')"></div>
      <div class="left side" v-bind:style="left" @click.prevent.stop="click($event, 'left')" @mousedown="mousedown($event, 'left')"></div>
      <div class="back side" v-bind:style="back" @click.prevent.stop="click($event, 'back')" @mousedown="mousedown($event, 'back')"></div>
    </div>

</template>


<script>
  export default {
    name: 'pack',
    props: {
      initPos: {
        type: Number,
        required: false,
      },
      initWidth: {
        type: Number,
        required: true,
      },
      initHeight: {
        type: Number,
        required: true,
      },
      initDepth: {
        type: Number,
        required: true,
      },
      isMirrored: {
        type: Boolean,
        default: false,
      },
      initFrontImg: {
        type: String,
        required: true,
      },
      initTopImg: {
        type: String,
        required: true,
      },
      initRightImg: {
        type: String,
        required: true,
      },
      initLeftImg: {
        type: String,
        required: true,
      },
      initBottomImg: {
        type: String,
        required: true,
      },
      initBackImg: {
        type: String,
        required: true,
      },
      isDraggable: {
        type: Boolean,
        default: false,
      },
      x: { // x
        type: Number,
        required: false,
        default: 0,
      },
      y: { // y
        type: Number,
        required: false,
        default: 0,
      },
      z: { // z
        type: Number,
        required: false,
        default: 0,
      },
      zIndex: {
        type: Number,
        required: false,
        default: 1,
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
      selected: {
        type: Boolean,
        default: false,
      },
      zoom: {
        type: Number,
        required: false,
        default: 1,
      },
      screenshot: {
        type: Boolean,
        default: false,
      },
      dominantColor: {
        type: String,
        required: false,
        default: '',
      },
    },
    computed: {
      holderClass() {
        return this.selected ? '--selected' : '';
      },
      width() {
        return this.initWidth * this.zoom;
      },
      height() {
        return this.pos === 0 ? this.initHeight * this.zoom : this.initDepth * this.zoom;
      },
      depth() {
        return this.pos === 0 ? this.initDepth * this.zoom : this.initHeight * this.zoom;
      },
      topImg() {
        return this.pos === 0 ? this.initTopImg : this.initFrontImg;
      },
      frontImg() {
        return this.pos === 0 ? this.initFrontImg : this.initBottomImg;
      },
      backImg() {
        return this.pos === 0 ? this.initBackImg : this.initTopImg;
      },
      bottomImg() {
        return this.pos === 0 ? this.initBottomImg : this.initBackImg;
      },
      rightImg() {
        return this.initRightImg;
      },
      front() {
        return {
          width: `${this.width}px`,
          height: `${this.height}px`,
          backgroundColor: this.dominantColor,
          backgroundSize: `${this.width}px ${this.height}px`,
          backgroundImage: `url("${this.frontImg}")`,
          transform: 'translate3d(0, 0, 0)',
        };
      },
      back() {
        return {
          width: `${this.width}px`,
          height: `${this.height}px`,
          backgroundColor: this.dominantColor,
          backgroundSize: `${this.width}px ${this.height}px`,
          backgroundImage: `url("${this.backImg}")`,
          transform: `translate3d(100%, 0, -${this.depth}px) rotate3d(0, -1, 0, 180deg)`,
          display: this.screenshot ? 'none' : '',
        };
      },
      left() {
        return {
          width: `${this.height}px`,
          height: `${this.depth}px`,
          backgroundColor: this.dominantColor,
          backgroundSize: `${this.height}px ${this.depth}px`,
          backgroundImage: `url("${this.initLeftImg}")`,
          transform: `translate3d(0, 0, -${this.depth}px) rotateY(-90deg) rotateZ(-90deg)`,
        };
      },
      bottom() {
        return {
          width: `${this.width}px`,
          height: `${this.depth}px`,
          backgroundColor: this.dominantColor,
          backgroundSize: `${this.width}px ${this.depth}px`,
          backgroundImage: `url("${this.bottomImg}")`,
          transform: 'translate3d(0, 0, 0) rotate3d(1, 0, 0, -90deg)',
        };
      },
      right() {
        return {
          width: `${this.depth}px`,
          height: `${this.height}px`,
          backgroundColor: this.dominantColor,
          backgroundSize: `${this.depth}px ${this.height}px`,
          backgroundImage: `url("${this.initRightImg}")`,
          transform: 'translate3d(0, 0, 0) rotateY(90deg)',
        };
      },
      top() {
        return {
          width: `${this.width}px`,
          height: `${this.depth}px`,
          backgroundColor: this.dominantColor,
          backgroundSize: `${this.width}px ${this.depth}px`,
          backgroundImage: `url("${this.topImg}")`,
          transform: 'translate3d(0, 0, 0px) rotate3d(1, 0, 0, 90deg)',
        };
      },
      holder() {
        return {
          height: this.height,
          width: this.width,
          depth: this.depth,
        };
      },
      holderWithPx() {
        return {
          height: `${this.holder.height}px`,
          width: `${this.holder.width}px`,
          transform: `translate3d(${this.x}px, ${this.y}px,${this.z}px)`,
        };
      },
    },
    watch: {
      holder() {
        const size = {};
        size.width = this.holder.width;
        size.height = this.holder.height;
        size.depth = this.holder.depth;
        size.frontWidth = this.width;
        this.$emit('sizeCalcutated', { size, id: this.id });
      },
      initPos() {
        this.pos = this.initPos;
      },
    },
    methods: {
      dblClick() {
        this.$emit('removePack', this.id);
      },
      click(e, side) {
        if (e.shiftKey && !e.altKey) {
          this.$emit('moveToSide', {
            id: this.id,
            event: e,
            offsetX: e.clientX - this.$el.offsetLeft,
            offsetY: e.clientY - this.$el.offsetTop,
            x: this.x,
            y: this.y,
            side,
          });
        } else if (e.altKey && !e.shiftKey) {
          this.$emit('select', {
            id: this.id,
            event: e,
            offsetX: e.clientX - this.$el.offsetLeft,
            offsetY: e.clientY - this.$el.offsetTop,
            x: this.x,
            y: this.y,
            side,
          });
        } else if (e.altKey && e.shiftKey) {
          this.$emit('rotate', this.id);
        } else {
          this.$emit('click', this.id);
        }
      },
      mousedown(e, side) {
        if (!e.metaKey) {
          this.$emit('mousedown', {
            id: this.id,
            event: e,
            offsetX: e.clientX - this.x,
            offsetY: e.clientY - this.y,
            offsetZ: e.clientY - this.z,
            side,
            x: this.x,
            y: this.y,
            z: this.z,
          });
        }
      },
    },
    data() {
      return {
        pos: this.initPos,
      };
    },
    created() {
      const size = {};
      size.width = this.holder.width;
      size.height = this.holder.height;
      size.frontWidth = this.width;
      size.depth = this.holder.depth;
      this.$emit('sizeCalcutated', { size, id: this.id });
    },
  };
</script>

<style lang="less" scoped>
  .holder{
    position: absolute;
  }

  .pack{
    position: absolute;
    transform-style: preserve-3d;
    perspective-origin: 100% 0;
  }

  .side {
    position: absolute;
    display: block;
    background: #ddd;
  }


  .front {
    top: 0;
    left: 0;
  }

  .right {
    top: 0;
    left: 100%;
    transform-origin: 0 0;
  }

  .bottom {
    top: 100%;
    left: 0;
    transform-origin: 0 0;
  }

  .left {
    top: 0;
    right: 100%;
    transform-origin: 100% 0;
  }

  .top {
    bottom: 100%;
    left: 0;
    transform-origin: 0 100%;
  }

  .back {
    top: 0;
    left: 0;
    transform-origin: 0 50%;
  }



  .--selected{
    .front,.top,.right{
      &::after{
        position: absolute;
        content: "";
        background: rgba(255,0,0,0.2);
        left:0;
        right:0;
        top:0;
        bottom:0;
      }
    }
  }

  .after-fader{
    position: absolute;
    content: "";
    left: 0;
    top:0;
    right: 0;
    bottom: 0;
  }

</style>


// WEBPACK FOOTER //
// Pack.vue?5d6e8a26